'use client';

import Loader from '@/components/ui/Loader';
import SessionProvider from '@/provider/SessionProvider';
import { LocaleProps } from '@/types/routes-types';
import { useTranslations } from 'next-intl';
import { Suspense } from 'react';
import '../../../globals.css';
import AccountTabs from './components/AccountTabs';

type Props = {
    children: React.ReactNode;
    params: LocaleProps;
};

export default function Layout({ children, params: { locale } }: Props) {
    const t = useTranslations();

    return (
        <SessionProvider>
            <div className="2xl:w-5/6 2xl:pr-[5%] xl:ml-auto 2xl:-translate-y-16 overflow-hidden pr-5">
                <h1 className="text-h4 lg:text-h1 pb-3 lg:pb-10 uppercase">
                    {t('Account.myAccount')}
                </h1>
                <AccountTabs />
                <Suspense fallback={<Loader />}>{children}</Suspense>
            </div>
        </SessionProvider>
    );
}
